import { CraftingResources } from '@components/arsenal/forge/CraftingResources';
import { EquipmentDisplay } from '@components/helpers/EquipmentDisplay';
import { CraftingTimer } from '@components/arsenal/forge/CraftingTimer';
import { ItemInfo } from '@components/arsenal/inventory/ItemInfo';
import { useTranslation } from 'react-i18next';
import { Modal } from '@components/ui/Modal';
import * as Shared from '@shared/lib';
import { useState } from 'react';

interface ItemCraftingProps {
  item: string;
  amount?: number;
  finishesAt?: string;
}

export function ItemCrafting({ item, amount, finishesAt }: ItemCraftingProps) {
  const [showInfo, setShowInfo] = useState(false);

  const { t } = useTranslation(undefined, { keyPrefix: 'Items' });

  const data = Shared.itemData.find((c) => c.key === item);
  if (!data) return null;

  const crafting = data.crafting;
  if (!crafting) return null;

  return (
    <>
      <Modal
        onRequestClose={() => setShowInfo(false)}
        isOpen={showInfo}
        title={t(item)}
      >
        <ItemInfo item={data.key} />
      </Modal>
      <EquipmentDisplay onClick={() => setShowInfo(true)} value={data.key} amount={amount} type="ITEM">
        {finishesAt && <CraftingTimer duration={crafting.duration} finishesAt={finishesAt} />}
        {!finishesAt && <CraftingResources crafting={crafting} />}
      </EquipmentDisplay>
    </>
  );
}